import * as React from "react";
import { withRouter } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import MyChartContainer from "../mychart/MyChartContainer";
import * as types from "../../constants/actionTypes";
import * as ProxyHelper from "../proxyManagement/ProxyHelper";

class CaptureInsurance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            onError: false,
            isLoaded: false,
            selectedSelfPay: false
        };
        this.onError = this.onError.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.closePage = this.closePage.bind(this);
        this.leaveOnWindowChange = this.leaveOnWindowChange.bind(this);
        this.submittedPreference = this.submittedPreference.bind(this);
        this.selfPaySubmit = this.selfPaySubmit.bind(this);
        this.submitAndContinue = false;
    }

    componentDidMount() {
        const { hasMyChartLogin, showInsuranceForm, useOnboardingLayout, isAdult } = this.props;
        logUI(`MBHWeb.UI.CaptureInsurance.ComponentDidMount${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());

        let skipPage = !hasMyChartLogin || !showInsuranceForm || !isAdult;

        if (skipPage) {

            let skipReason = this.getSkipReason();
            skipReason = skipReason && skipReason === "" ? "" : ".".concat(skipReason);
            let logActivityCode = `MBHWeb.UI.CaptureInsurance.Skipped${skipReason}${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`;
            logUI(logActivityCode, new Date(), Tools.getURLPath());
            this.closePage();
        }
    }

    getSkipReason() {
        const { hasMyChartLogin, showFamilyMembersScreen, isAdult } = this.props;
        if (!isAdult)
            return "isMinor";
        else if (!showFamilyMembersScreen)
            return "InsurancePreferenceIsFalse";
        else if (!hasMyChartLogin)
            return "NoMyChart";
        else
            return "";

    }

    onError() {
        if (!this.state.onError) {
            this.setState({ onError: true });
        }
    }

    onIframeLoaded = (isLoaded) => {
        this.setState({
            isLoaded
        });
    }

    onSubmit(isSubmitted) {
        this.submitAndContinue = isSubmitted;
        const { useOnboardingLayout } = this.props;
        // Submit or SelfPay is clicked - so now we can update PreferenceValue
        if (typeof window !== 'undefined' && !window.formChanged) {
            logUI(`MBHWeb.UI.CaptureInsurance.onSubmit${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
            this.submittedPreference();
        } else {
            logUI(`MBHWeb.UI.CaptureInsurance.Update.onSubmit${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
            this.closePage();
        }
    }

    closePage() {
        const { history } = this.props;
        try {
            history.push("/onboarding/familymembers");
        }
        catch (e) {
            window.location.href = "/";
        }
    }

    leaveOnWindowChange() {
        const { useOnboardingLayout } = this.props;
        logUI(`MBHWeb.UI.CaptureInsurance.LeaveOnWindowChange${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.submittedPreference();
    }

    submittedPreference() {
        const { useOnboardingLayout } = this.props;
        if (this.submitAndContinue) {
            logUI(`MBHWeb.UI.CaptureInsurance.SubmitAndContinue${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
            this.props.updatePreferenceValue();
            this.closePage();
        }
        else {
            logUI(`MBHWeb.UI.CaptureInsurance.SelfPay${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
            this.setState({
                selectedSelfPay: true
            });
        }
    }

    selfPaySubmit() {
        const { useOnboardingLayout } = this.props;
        logUI(`MBHWeb.UI.CaptureInsurance.SelfPay.Ok${ProxyHelper.getLogLayoutStatus(useOnboardingLayout)}`, new Date(), Tools.getURLPath());
        this.props.updatePreferenceValue();
        this.closePage();
    }

    render() {
        const { serverData } = this.props;
        const { isLoaded, selectedSelfPay } = this.state;

        const footer = (<div className="row text-center form-footer-group">
            <div className="col-12 maxWidth-content">
                <div className="row">
                    <div className="col-12">
                        <button
                            type="button"
                            className="btn btn-primary"
                            disabled={!isLoaded}
                            onClick={() => this.onSubmit(true)}
                        >
                            SUBMIT AND CONTINUE
                        </button>
                    </div>
                    <div className="col-12">
                        <button
                            type="button"
                            className="btn text-btn"
                            disabled={!isLoaded}
                            onClick={() => this.selfPaySubmit()}
                        >
                            SKIP INSURANCE
                        </button>
                    </div>
                </div>
            </div>
        </div>);

        const dismissedMsg = (
            <div className="container-fluid capture-insurance-container insurance-dismissed-msg">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12 text-center">
                                <h1 className="page-heading">You can add insurance later by going to Insurance & Billing then Insurances on File.</h1>
                            </div>
                        </div>
                        <div className="row text-center form-footer-group">
                            <div className="col-12">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!isLoaded}
                                    onClick={() => this.selfPaySubmit()}
                                >
                                    GOT IT
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);

        return (
            <>
                {!selectedSelfPay
                    ? <MyChartContainer
                        containerClass="capture-insurance-container"
                        mode="insurance"
                        title="Insurance"
                        serverData={serverData}
                        mychartError={this.onError}
                        footer={footer}
                        onIframeLoaded={this.onIframeLoaded}
                        leaveOnWindowChange={this.leaveOnWindowChange}
                        confirmationModalMsg={"Are you sure you would like to continue?"}
                        confirmationModalBtnTxt1={"STAY ON THIS PAGE"}
                        confirmationModalBtnTxt2={"CONTINUE"}
                    />
                    : dismissedMsg
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {

    let userAge = state.domain.cu?.ay || state.domain.age;
    return {
        serverData: state.session.serverData,
        hasMyChartLogin: state.domain.hm,
        showInsuranceForm: state.session.showInsuranceForm,
        useOnboardingLayout: state.session.useOnboardingLayout,
        isAdult: userAge && userAge > 18 ? true : false,        
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updatePreferenceValue: () => dispatch({
            type: types.UPDATE_INSURANCE_PREFERENCE
        })
    };
};

export default withRouter(connect(
    mapStateToProps, mapDispatchToProps
)(CaptureInsurance));